import ProjectListPage from '@/modules/projects/ProjectListPage';
import ProjectMain from '@/modules/projects/ProjectMain';

export default [
	{
		path: '/projects',
		name: 'Projects',
		component: ProjectListPage,
	},
	{
		path: '/projects/:projectId',
		name: 'ProjectDetail',
		component: ProjectMain,
		props: (route) => ({
			v: route.query.v,
			projectId: route.params.projectId,
		}),
	}
]
